@let isDesktop = deviceService.isDesktop$ | async;

@for (status of $visibleStatuses(); track status.id; let last = $last) {
  @if ($insideDropdown()) {
    <div
      [ngClass]="{
        'mb-[12px]': !last,
        'x-font-body-3-bold': isDesktop,
        'x-font-body-4-bold': !isDesktop,
      }"
    >
      <span
        tuiChip
        class="x-status-chip cursor-pointer"
        [style.background]="hexToRgba(status!.color, 0.5)"
        (click)="handleClick(status)"
        >{{ 'request_statuses.' + status.id | translate }}</span
      >
    </div>
  } @else {
    <div
      class="flex justify-between py-3 cursor-pointer"
      [class.border-b]="!last"
    >
      <div class="ml-5 mr-3 w-full" (click)="handleClick(status)">
        <div class="text-sm">
          <span
            class="inline-block w-4 h-4 rounded-full align-middle"
            [style.background-color]="status.color"
          ></span>
          <span
            class="inline-block align-middle ml-2 {{
              status.id === value?.id ? 'text-[#ed5565] font-semibold' : ''
            }}"
            >{{ 'request_statuses.' + status.id | translate }}</span
          >
        </div>
      </div>
      <input
        tuiRadio
        type="radio"
        size="m"
        class="mr-5"
        [checked]="status.id === value?.id"
        [disabled]="!!(isLoading$ | async)"
        (click)="$readOnly() && $event.preventDefault()"
        (change)="handleClick(status)"
      />
    </div>
  }
}
